import React, { Fragment, useCallback, useEffect, useState } from "react";
import "./index.css";
import { Button, Card, Col, Row, Spin, Tooltip } from "antd";
import I18n from "../../../../i18n";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../application/store";
import { loadUser } from "../../../../../application/user-slice";
import { isMobile } from "react-device-detect";
import { ArrowRightOutlined, EditOutlined } from "@ant-design/icons";
import EditEmailModal from "./components/EditEmailModal";
import EditNameModal from "./components/EditNameModal";
import EditPasswordModal from "./components/EditPasswordModal";
import { DocumentTitle } from "../../../../components";
import { useHistory } from "react-router-dom";

const AccountInfoItem: React.FC<{
  title: string;
  onClick: () => void;
  disabled: boolean;
  value?: string;
  isOddChild?: boolean;
  hideEditButton?: boolean;
}> = ({ title, onClick, disabled, isOddChild, value, hideEditButton }) => (
  <Col
    md={12}
    className={`account-info-item ${
      isMobile && isOddChild ? "" : "account-info-item-border-left"
    }`}
  >
    <Row justify="space-between">
      <div className="account-info-item-title">{title}</div>
      {!hideEditButton ? (
        <Tooltip title={I18n.profile.edit} placement="bottomRight">
          <Button
            icon={<EditOutlined />}
            type="link"
            onClick={onClick}
            disabled={disabled}
          />
        </Tooltip>
      ) : (
        <div style={{ height: 40 }} />
      )}
    </Row>
    <div className="account-info-item-value">{value}</div>
  </Col>
);

export default function AccountInfo() {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const user = useAppSelector((state) => state.user);
  const { userInfo, loading } = user;

  const [editNameModalVisible, setEditNameModalVisible] = useState(false);
  const openEditNameModal = () => setEditNameModalVisible(true);
  const closeEditNameModal = () => setEditNameModalVisible(false);

  const [editEmailModalVisible, setEditEmailModalVisible] = useState(false);
  const openEditEmailModal = () => setEditEmailModalVisible(true);
  const closeEditEmailModal = () => setEditEmailModalVisible(false);

  const [editPasswordModalVisible, setEditPasswordModalVisible] = useState(
    false
  );
  const openEditPasswordModal = () => setEditPasswordModalVisible(true);
  const closeEditPasswordModal = () => setEditPasswordModalVisible(false);

  const stableDispatch = useCallback(dispatch, []);
  useEffect(() => {
    stableDispatch(loadUser());
  }, [stableDispatch]);

  const isLoading = loading === "pending";
  return (
    <DocumentTitle title={I18n.profile.tabs.accountInfo}>
      <Card bodyStyle={{ padding: 0 }}>
        <Row
          justify="space-between"
          className={`account-info-title${
            isMobile ? " account-info-title-mobile" : ""
          }`}
          align="middle"
        >
          <Row>
            {isMobile ? (
              <Button
                style={{ marginLeft: 8 }}
                type="text"
                size="small"
                onClick={() => history.goBack()}
              >
                <ArrowRightOutlined />
              </Button>
            ) : (
              <Fragment />
            )}
            <div>{I18n.profile.tabs.accountInfo}</div>
          </Row>
          <Button
            size="small"
            type="link"
            disabled={isLoading}
            onClick={openEditPasswordModal}
          >
            {I18n.chanePassword.title}
          </Button>
        </Row>
        <Spin spinning={isLoading}>
          <Row>
            <AccountInfoItem
              title={I18n.profile.accountInfo.firstName}
              value={userInfo?.firstName}
              disabled={isLoading}
              onClick={openEditNameModal}
              isOddChild
            />
            <AccountInfoItem
              title={I18n.profile.accountInfo.sureName}
              value={userInfo?.sureName}
              disabled={isLoading}
              onClick={openEditNameModal}
            />
          </Row>
          <Row>
            <AccountInfoItem
              title={I18n.profile.accountInfo.phoneNumber}
              value={userInfo?.phoneNumber}
              disabled={isLoading}
              onClick={() => {}}
              isOddChild
              hideEditButton
            />
            <AccountInfoItem
              title={I18n.profile.accountInfo.email}
              value={userInfo?.email === "" ? "-" : userInfo?.email}
              disabled={isLoading}
              onClick={openEditEmailModal}
            />
          </Row>
        </Spin>
        <EditEmailModal
          visible={editEmailModalVisible}
          onClose={closeEditEmailModal}
          currentEmail={userInfo?.email}
        />
        <EditNameModal
          visible={editNameModalVisible}
          onClose={closeEditNameModal}
          currentFirstName={userInfo?.firstName}
          currentSureName={userInfo?.sureName}
        />
        <EditPasswordModal
          visible={editPasswordModalVisible}
          onClose={closeEditPasswordModal}
        />
      </Card>
    </DocumentTitle>
  );
}
